var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-back"},[_c('a',{class:`go-back__link go-back__link-${_vm.variant}`,on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('FontAwesomeIcon',{staticClass:"go-back__link-icon",attrs:{"icon":"arrow-left"}}),_vm._v(" "+_vm._s(_vm.data.label || _vm.$t('goBack')))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }